class TG_ProductQuickviewVariant {
    constructor(container) {
  
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
      this.productVariants = new themegoal.components_business.product_variants.ProductVariants(this.element, this.options);

      this.mediaIdIndexs = null;
      if(this.element.querySelector('[data-product-media-id-index-json]')){
        let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
        this.mediaIdIndexs = productMediaJsonData['media_id_index'];
      }
    
      let productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
      let productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
  
      if (productSlideshowElement) {
        this.productSlideshow = new themegoal.components.Carousel(productSlideshowElement);
      }
  
      if (productSlideshowNavElement) {
        new themegoal.components.Carousel(productSlideshowNavElement);
      }
  
      this._bindEventsListeners();
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
    }

    _updateSlideshowImage(event) {
      var _this = this;
      var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;
  
      if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
          return;
      }
  
      let variantFeaturedMediaId = variant['featured_media']['id'];

      if (this.options['galleryDesign'] == 'carousel' && this.productSlideshow) {
        if(this.options["enableMediaGrouping"]&&previousVariant.options[0]!=variant.options[0]){
          this.mediaIdIndexs = null;
          if(this.element.querySelector('[data-product-media-id-index-json]')){
            let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
            this.mediaIdIndexs = productMediaJsonData['media_id_index'];
          }
          this.productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
          this.productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
          
          if (this.productSlideshowNavElement) {
            this.productSlideshowNav = new themegoal.components.Carousel(this.productSlideshowNavElement);
          }

          if (this.productSlideshowElement) {
            this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
          }
        }
        
        if (this.mediaIdIndexs && this.mediaIdIndexs.hasOwnProperty("id_" + variantFeaturedMediaId)){
          this.productSlideshow.selectCell(this.mediaIdIndexs["id_" + variantFeaturedMediaId]);
        }

        let carouselEle = _this.productSlideshow.carouselInstance.el.querySelectorAll(".Carousel__Item");
          carouselEle.forEach(function (ele) {
            ele.classList.remove("Carousel__Item--currentItem");
          });

        setTimeout(function () {
          let carouselEle = _this.productSlideshow.carouselInstance.el.querySelectorAll(".Carousel__Item");
          carouselEle.forEach(function (ele) {
            if(ele.classList.contains("Carousel__Item--active") && !ele.classList.contains("Carousel__Item--currentItem"))
            ele.classList.add("Carousel__Item--currentItem"); 
          });
        }, 800);
      } 
    
    }
  
  }
  
  class TG_ProductQuickvew {
    constructor() {
      this.element = document.body;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.quiviewModal = null;

      this._attachListeners();
    }
  
    _attachListeners() {
      this.delegateElement.on('click', '[data-tg-action="product-quickview-modal"]', this._debounce(this._openModal.bind(this), 1000)); 
    }
  
    _openModal(event,target) {
      let _this = this;
  
      let productURL = target.getAttribute('data-product-handle');

      if(productURL){
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        target.classList.add("Loading");
  
        fetch(window.routes.rootUrlWithoutSlash+'/products/'+productURL+'?section_id=product-quickview', {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));

            target.classList.remove("Loading");
            var tempElement = document.createElement('div');
            tempElement.innerHTML = content;

            _this.element.querySelector("#shopify-section-product-quickview").innerHTML = tempElement.querySelector("#shopify-section-product-quickview").innerHTML;

            let ele = document.getElementById('ProductQuickviewModal');

            document.querySelector("body").style.removeProperty('overflow');
            
            _this.quiviewModal = new themegoal.components.Modal(ele);
            ele.addEventListener('shown.tg.Modal', event => {
              new TG_ProductQuickviewVariant(_this.element.querySelector(".ProductQuickview"));
            })
        
            _this.quiviewModal.show();
              
          });
        });
      
      }
    }
  
    _debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  
  }

  new TG_ProductQuickvew();

  